import React, { useState, useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { useTheme } from '../../../context/theme-context';
import './NoticeBanner.less';

interface IUrlMap {
  [key: string]: string;
}

export const NoticeBanner = (): JSX.Element | null => {
  const theme: string = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  const TERMS_OF_USE_URLS: IUrlMap = {
    uhc: 'https://www.uhc.com/content/dam/uhcdotcom/en/npp/TOU-UHC-TIC-Public-EN.pdf',
    optum: 'https://www.uhc.com/content/dam/uhcdotcom/en/npp/TOU-Optum-TIC-Public-EN.pdf',
  };

  const PRIVACY_POLICY_URLS: IUrlMap = {
    uhc: 'https://www.uhc.com/content/dam/uhcdotcom/en/npp/OSPP-UHC-TIC-Public-EN.pdf',
    optum: 'https://www.uhc.com/content/dam/uhcdotcom/en/npp/OSPP-Optum-TIC-Public-EN.pdf',
  };

  useEffect(() => {
    // Check if the banner has been dismissed
    const isBannerDismissed = localStorage.getItem('noticeBannerDismissed');
    if (!isBannerDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = (): void => {
    setIsVisible(false);
    localStorage.setItem('noticeBannerDismissed', 'true');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className='notice-banner'>
      <div className='notice-banner-content'>
        <span className='notice-banner-text'>
          <strong>Notice:</strong> We use cookies and similar tools to make your use of this website easy and to keep it
          working properly. We may share data about you and how you use the site with third parties, such as analytics
          and marketing partners. Learn more in our{' '}
          <a
            href={PRIVACY_POLICY_URLS[theme]}
            target='_blank'
            rel='noreferrer'
            className='notice-banner-link'
            aria-label='Privacy Policy'
          >
            Privacy Policy
          </a>{' '}
          and{' '}
          <a
            href={TERMS_OF_USE_URLS[theme]}
            target='_blank'
            rel='noreferrer'
            className='notice-banner-link'
            aria-label='Terms of Use'
          >
            Terms of Use
          </a>
          . By continuing to use the site, you agree to this.
        </span>
      </div>
      <button className='notice-banner-close' onClick={handleClose} aria-label='Close notice banner' type='button'>
        <CloseOutlined />
      </button>
    </div>
  );
};
